import React from 'react'
import { Link } from 'react-router-dom'
import SectionTitle2 from '../SectionTitle2';
import { useTranslation } from 'react-i18next';



const Pricing = ({ pricingData, pricingIsLoading, pricingIsError }) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    const { t } = useTranslation();


    return (
        <section className={`wpo-pricing-section section-padding wpo-pricing-section-s2`}>
            <div className="container">
                <SectionTitle2
                    subTitle={t('sectionTitle.pricingPlan.subtitle')}
                    MainTitle={t('sectionTitle.pricingPlan.mainTitle')}
                    vText={t('sectionTitle.pricingPlan.vText')}
                />                <div className="wpo-pricing-wrap">
                    <div className="row">
                        {pricingIsLoading ? <p>{t("loading")}...</p> : pricingIsError ? <p>{t("error")}</p> : pricingData.map((pricing, ptem) => (
                            <div className="col col-lg-4 col-md-6 col-12" key={ptem}>
                                <div className="wpo-pricing-item">
                                    <div className="wpo-pricing-top">
                                        <div className="pricing-thumb">
                                            {/* <span>{pricing.package}</span> */}
                                        </div>
                                        <div className="wpo-pricing-text">
                                            <h2 >{pricing?.pricing?.monthly["AED"]} OMR</h2>
                                            <p>{pricing?.package}</p>
                                        </div>
                                    </div>
                                    <div className="wpo-pricing-bottom">
                                        <div className="wpo-pricing-bottom-text">
                                            <ul>
                                                {pricing?.features?.map((feature, ftem) => (
                                                    <li key={ftem}>{feature}</li>
                                                ))}
                                            </ul>
                                            <Link to={"/contact"}>{t('choosePlan')}</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="invisible-title1">
                <h2>Pricing</h2>
            </div>
        </section>
    )
}

export default Pricing;